export const MOBILE_IDS = ['sdkVersion', 'appVersion', 'deviceModel', 'osVersion'];

export const MOBILE_PLATFORMS = ['ios', 'android'];
